import type { PhotoSlot } from './types'

export function getSlotId(index: number): PhotoSlot {
  return index === 0 ? 'primary' : `slot-${index}`
}

export function getSlotIndex(slot: PhotoSlot): number {
  return slot === 'primary' ? 0 : parseInt(slot.replace('slot-', ''), 10)
}

export function sortBySlot<TItem extends { slot: PhotoSlot }>(items: TItem[]): TItem[] {
  return items.slice().sort((left, right) => getSlotIndex(left.slot) - getSlotIndex(right.slot))
}
